import React from 'react';
import { GatsbyImage, getImage, ImageDataLike } from 'gatsby-plugin-image';
import { SmartLink } from '../SmartLink/SmartLink';
import './InlineCallout.scss';

type InlineCalloutLink = {
    uri: string;
    title: string;
};
type InlineCalloutInputs = {
    header: string;
    link: InlineCalloutLink;
    body: string;
    image: ImageDataLike;
    imageAlt: string;
};

export const InlineCallout = ({ inputs }: { inputs: InlineCalloutInputs }) => {
    const hasLink = inputs.link?.uri && inputs.link?.uri !== `route:<nolink>`;

    return (
        <section className="inline-callout">
            {inputs.image && (
                <GatsbyImage
                    image={getImage(inputs.image)}
                    alt={inputs.imageAlt}
                />
            )}
            <div className="content">
                {inputs.header && (
                    <h3 className="typestack-title-5">{inputs.header}</h3>
                )}
                {inputs.body && (
                    <div
                        className="content__body"
                        dangerouslySetInnerHTML={{ __html: inputs.body }}
                    />
                )}
                {inputs.link &&
                    (hasLink ? (
                        <SmartLink
                            classNames={[`content__subtext`]}
                            url={inputs.link.uri}
                        >
                            {inputs.link.title}
                        </SmartLink>
                    ) : (
                        <p className="content__subtext">{inputs.link.title}</p>
                    ))}
            </div>
        </section>
    );
};
